import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

import type { Point } from '#shared';
import type { RootState } from '../redux-store';

interface RelationsState {
  $newCasesOnMap: Record<string, Point>;
  $geoMapCenter: Point;
}

const initialState: RelationsState = {
  $newCasesOnMap: {},
  $geoMapCenter: [0, 0],
};

export const relationsSlice = createSlice({
  name: 'relations',
  initialState,
  reducers: {
    // Skip update when coordinates are identical to avoid cascading re-renders
    // with React 19's stricter useSyncExternalStore (see widgetManager.slice.ts).
    setGeoMapCenter: (state, action: PayloadAction<Point>) => {
      if (
        state.$geoMapCenter[0] === action.payload[0] &&
        state.$geoMapCenter[1] === action.payload[1]
      ) {
        return;
      }
      state.$geoMapCenter = action.payload;
    },
    setNewCasesOnMap: (state, action: PayloadAction<Record<string, Point>>) => {
      state.$newCasesOnMap = action.payload;
    },
    clearNewCases: state => {
      state.$newCasesOnMap = {};
    },
  },
});

export const relationsSelectors = {
  useSelectNewCasesOnMap: () =>
    useSelector((s: RootState) => s.relations.$newCasesOnMap),
  useSelectGeoMapCenter: () =>
    useSelector((s: RootState) => s.relations.$geoMapCenter),
};

export const relationsReducer = relationsSlice.reducer;
export const relationsActions = relationsSlice.actions;
